import React, { useEffect } from 'react';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import FeaturesSection from '../components/home/FeaturesSection';
import PerformanceSection from '../components/home/PerformanceSection';
import PortfolioManagementSection from '../components/home/PortfolioManagementSection';
import PhilosophySection from '../components/home/PhilosophySection';
import TeamSection from '../components/home/TeamSection';
import ComprehensiveServicesSection from '../components/home/ComprehensiveServicesSection';
import NewsInsightsSection from '../components/home/NewsInsightsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import CtaSection from '../components/home/CtaSection';

const HomePage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeroSection />
      <AboutSection />
      <FeaturesSection />
      <PerformanceSection />
      <ComprehensiveServicesSection />
      <PhilosophySection />
      
      {/* <TeamSection /> */}
      {/* <NewsInsightsSection /> */}
      {/* <TestimonialsSection /> */}
      {/* <CtaSection /> */}
    </>
  );
};

export default HomePage; 